import { render, staticRenderFns } from "./PatrimoineList.vue?vue&type=template&id=0881b356&scoped=true&"
import script from "./PatrimoineList.vue?vue&type=script&lang=js&"
export * from "./PatrimoineList.vue?vue&type=script&lang=js&"
import style0 from "./PatrimoineList.vue?vue&type=style&index=0&id=0881b356&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0881b356",
  null
  
)

export default component.exports